import { Component, OnInit, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import * as moment from "moment";
import { BASE64_LOGO } from "../../shared/pdf-logo-base64";
declare var pdfMake: any;

import { Receipt } from "@shared/models";
import { Router } from "@angular/router";

@Component({
  selector: "app-receipt-dialog",
  templateUrl: "./receipt-dialog.component.html",
  styleUrls: ["./receipt-dialog.component.css"],
})
export class ReceiptDialogComponent implements OnInit {
  public createDate: string;
  public paymentId: string;
  public accountId: string;
  public amount: string;
  public currency: string;
  public username: string;
  public programDescription: string;
  public cardNumber: string;
  public authCode: string;
  public reference: string;
  private transactionId: string;
  private pdf: any;
  public status: string;

  constructor(
    private dialogRef: MatDialogRef<ReceiptDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _router : Router
  ) {}

  ngOnInit() {
    console.log(this.data);
    this.createDate = this.data.payment_dt;
    this.accountId = this.data.account_id;
    this.amount = this.data.amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
    this.currency = this.data.currency
      ? this.formatCurrency(this.data.currency)
      : "";
    this.paymentId = this.data.id;
    this.username = this.data.username.replace("_MOBL", "");
    this.programDescription = "Nexpress Account Payment";
    this.authCode = this.data.authCode ? this.data.authCode : "";
    this.reference = this.data.reference ? this.data.reference : "";
    this.cardNumber = this.data.cardNumber ? this.data.cardNumber : "";
    this.status = this.data.status ? this.data.status : "";
  }

  formatCurrency(s) {
    if (s == "CAND") {
      return "CAD";
    } else if (s == "USAD") {
      return "USD";
    } else {
      return s;
    }
  }

  printPDFReceipt() {
    this.pdf = pdfMake;
    const dateString = JSON.stringify(new Date());
    this.pdf
      .createPdf(this.buildPdf())
      .download("Detroit_Windsor_Tunnel_Receipt_" + dateString + ".pdf");
  }

  closeDialog(){
    console.log(this._router.url);
    if (this._router.url === '/makepayment') {
      this._router.navigate(["account"]);
      this.dialogRef.close();
    } else {
      this.dialogRef.close();
    }
  }

  buildPdf() {
    const docDefinition = {
      footer: [],
      content: [
        {
          margin: [0, 10],
          columns: [
            {
              image: BASE64_LOGO,
              width: 128,
            },
            {
              stack: [
                {
                  text: "Create date: " + moment(this.createDate).format("lll"),
                  alignment: "right",
                },
                {
                  text: "Transaction ID: " + this.paymentId,
                  alignment: "right",
                },
              ],
            },
          ],
        },
        {
          stack: [
            {
              text: this.username,
              margin: [0, 0, 0, 10],
              bold: true,
            },
            {
              text:
                "Receipt for payment received on Account ID: " + this.accountId,
              margin: [0, 0, 0, 20],
              color: "#C88039",
              bold: true,
            },
          ],
        },
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 5,
              x2: 595 - 2 * 40,
              y2: 5,
              lineWidth: 0.5,
              color: "#666666",
            },
          ],
          alignment: "center",
          margin: [0, 0, 0, 10],
        },
        {
          stack: [
            {
              text: "Paid to: ",
              bold: true,
            },
            {
              text: "Detroit Windsor Tunnel",
            },
            {
              text: "nexpresshelpdesk@dwtunnel.com",
            },
          ],
          margin: [0, 0, 0, 10],
        },
        {
          table: {
            widths: ["*", "*", "10%", "10%", "*", "*"],
            body: [
              [{ text: "Payment:", bold: true }, "Credit Card", "", "", "", ""],
              [
                { text: "Card ending in:", bold: true },
                this.cardNumber.toString(),
                "",
                "",
                { text: "Status: ", bold: true },
                this.status.toString(),
              ],
              [
                { text: "Auth Code:", bold: true },
                this.authCode.toString(),
                "",
                "",
                { text: "Ref ID:", bold: true },
                this.reference.toString(),
              ],
            ],
          },
          layout: "noBorders",
          margin: [0, 20, 0, 20],
        },
        {
          table: {
            headerRows: 1,
            widths: ["70%", "30%"],
            body: [
              [
                { text: "Description", bold: true, margin: [5, 0, 0, 0] },
                {
                  text: "Amount",
                  bold: true,
                  alignment: "right",
                  margin: [0, 0, 5, 0],
                },
              ],
              [
                { text: "Nexpress Account Payment", margin: [5, 0, 0, 0] },
                {
                  text: this.amount.toString() + " " + this.currency,
                  alignment: "right",
                  margin: [0, 0, 5, 0],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return 1;
              }
              return i === node.table.headerRows ? 2 : 1;
            },
            vLineWidth: function (i) {
              return 0;
            },
            hLineColor: function (i) {
              return i === 1 ? "#ddd" : "#ddd";
            },
            paddingLeft: function (i) {
              return i === 0 ? 0 : 8;
            },
            paddingRight: function (i, node) {
              return i === node.table.widths.length - 1 ? 0 : 8;
            },
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex % 2 === 0 ? "#ddd" : null;
            },
          },
          margin: [0, 20, 0, 120],
        },
        {
          text: `Payment will be shown as ${this.currency == "CAD" ? "Windsor Detroit Border":"Detroit Windsor Tunnel"}`,
          alignment: "center",
          bold: true,
        },
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 5,
              x2: 595 - 2 * 40,
              y2: 5,
              lineWidth: 0.5,
              color: "#666666",
            },
          ],
          alignment: "center",
          margin: [0, 20, 0, 10],
        },
        {
          text:
            "Copyright " +
            new Date().getFullYear() +
            " DWTunnel. All rights reserved.",
        },
        {
          stack: [
            {
              text: "Detroit Windsor Tunnel LLC",
            },
            {
              text: "100 E. Jefferson Avenue",
            },
            {
              text: "Detroit, MI 48226",
            },
          ],
        },
      ],
    };
    return docDefinition;
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/receipt-dialog/receipt-dialog.component.ts